export const PrimeMoverTypes = {
  TWO_STROKE_ENGINE: 'two_stroke_engine',
  FOUR_STROKE_ENGINE: 'four_stroke_engine',
  DIESEL_ELECTRIC_PROPULSION: 'diesel_electric_propulsion',
  LBSI: 'lbsi',
  STEAM_TURBINE_PROPULSION: 'steam_turbine_propulsion',
} as const;

export type PrimeMoverType = (typeof PrimeMoverTypes)[keyof typeof PrimeMoverTypes];
